import PageHeading from '../components/common/PageHeading';
import { serviceItems } from '../data/siteContent';

function ServicesPage() {
  return (
    <section className="page-section" aria-labelledby="services-title">
      <PageHeading
        id="services-title"
        label="서비스"
        title="말타가 연결하는 승마 경험"
        description="승마장을 찾는 사용자와 더 효율적인 운영이 필요한 파트너를 함께 지원합니다."
      />
      <div className="service-grid">
        {serviceItems.map((item) => (
          <article className="surface-card" key={item.title}>
            <h2>{item.title}</h2>
            <p>{item.body}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default ServicesPage;
